import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import useEligibleServicesLine from './hooks/useEligibleServicesLine';
import EligibleServicesModal from './EligibleServicesModal';

interface Props {
  policyId?: number | string;
  accountName?: string;
  accountType?: string;
}

const EligibleServicesField: React.FC<Props> = ({ policyId, accountName, accountType }) => {
  const { displayLabel, categories, extraCount, total, isLoading, handleOpenModal } =
    useEligibleServicesLine(policyId);

  if (isLoading || total === 0) {
    return null;
  }

  return (
    <>
      <Box
        data-testid="eligible-services-field_wrapper"
        direction="row"
        height={{ min: '40px' }}
        align="start"
      >
        <Box width={{ max: '256px', min: '256px' }}>
          <Text size="medium" weight={700} style={{ lineHeight: '20px' }}>
            Eligible services covered by this account
          </Text>
        </Box>
        <Box direction="row" align="center" gap="xxsmall">
          <Text
            data-testid="eligible-services-field_text"
            size="medium"
            weight={400}
          >
            {displayLabel}
          </Text>
          {extraCount > 0 && (
            <Text
              data-testid="eligible-services-field_extra-count"
              size="small"
              weight={500}
              color="textAccent"
              style={{ cursor: 'pointer' }}
              onClick={handleOpenModal}
            >
              {`+${extraCount}`}
            </Text>
          )}
        </Box>
      </Box>
      <EligibleServicesModal
        categories={categories}
        accountName={accountName}
        accountType={accountType}
        policyId={policyId}
      />
    </>
  );
};

export default EligibleServicesField;
